import { RouteConfig } from "vue-router";

export const RGuideTemplate: RouteConfig = {
  path: ":id(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "guide-template" */
      "./VGuideTemplate.vue"
    ),
  meta: {
    backLink: "/guide",
  },
};
